import orderId from "./order/id";
import productId from "./product/id";

const categoryId = {
	category: {
		...productId,
		...orderId,
	},
};

export default categoryId;
